import http from "@/plugins/axios";

export default {
    export2Excel(columns, list, title) {
        require.ensure([], () => {
            const {export_json_to_excel} = require('../../../excel/Export2Excel');
            let tHeader = []
            let filterVal = []
            if (!columns) {
                return;
            }
            columns.forEach(item => {
                tHeader.push(item.title)
                filterVal.push(item.key)
            })
            const data = list.map(v => filterVal.map(j => v[j]))
            export_json_to_excel(tHeader, data, title);
        });
    },

    requestData(requestUrl){
        return http.get({
            url:requestUrl,
        })
    },

    unique(arr) {
        return Array.from(new Set(arr))
    },

    queryStrategyData(data){
        return http.post({
            url: '/admin/hedge/stats/strategy',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'  // application/x-www-form-urlencoded  application/json
            }
        })
    },

    queryStrategySrcRecords(data){
        return http.post({
            url: '/admin/hedge/query/strategy/src/records',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryAllStrategySrcRecords(data){
        return http.post({
            url: '/admin/hedge/query/src/records',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    batchMarkSrcRecordHedgeStatus(data){
        return http.post({
            url: '/admin/hedge/batch/mark/src/record',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryStrategyBatchRecords(data){
        return http.post({
            url: '/admin/hedge/query/strategy/batch/records',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryAllStrategyBatchRecords(data){
        return http.post({
            url: '/admin/hedge/query/batch/records',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryBatchRecordsById(data){
        return http.post({
            url: '/admin/hedge/query/one/batch/record',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    addManualHedgeRecord(data){
        return http.post({
            url: '/admin/hedge/add/manual/Hedge/record',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    removeManualBatchRecord(data){
        return http.post({
            url: '/admin/hedge/remove/manual/batch/record',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryHedgeHistoryBalance(data){
        return http.post({
            url: '/admin/hedge/query/hedge/history/balance',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    pageQuerySrcRecordsByBatchOrderId(data){
        return http.post({
            url: '/admin/hedge/query/src/record/by/id',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryExchangeAccountEnum(){
        return http.get({
            url: '/admin/hedge/query/exchange/account/enum',
        })
    },

    addHedgeDataSnapshot(data){
        return http.post({
            url: '/admin/hedge/add/data/snapshot',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    queryHedgeCycleBenefitStatistics(data){
        return http.post({
            url: '/admin/hedge/query/cycle/benefit/statistics',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    deleteHedgeCycleBenefitStatistics(data){
        return http.post({
            url: '/admin/hedge/delete/cycle/benefit/statistics',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    updateManualHedgeRecord(data){
        return http.post({
            url: '/admin/hedge/update/manual/Hedge/record',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    },

    urlJoin(url, params){
        let init = 0
        for (let key in params){
            if(init === 0){
                url = url+'?'+key+'='+params[key]
            }else{
                url = url+'&'+key+'='+params[key]
            }
            init = init + 1
        }
        return url
    },

    getLocalTime(unixTimeStamp) {
        if (unixTimeStamp){
            unixTimeStamp = new Date(unixTimeStamp)
            let Y = unixTimeStamp.getFullYear() + '-';
            let M = (unixTimeStamp.getMonth()+1 < 10 ? '0'+(unixTimeStamp.getMonth()+1) : unixTimeStamp.getMonth()+1) + '-';
            let D = (unixTimeStamp.getDate() < 10 ? '0'+unixTimeStamp.getDate() : unixTimeStamp.getDate()) + ' ';
            let h = (unixTimeStamp.getHours() < 10 ? '0'+unixTimeStamp.getHours() : unixTimeStamp.getHours()) + ':';
            let m = (unixTimeStamp.getMinutes() < 10 ? '0'+unixTimeStamp.getMinutes() : unixTimeStamp.getMinutes()) + ':';
            let s = (unixTimeStamp.getSeconds() < 10 ? '0'+unixTimeStamp.getSeconds() : unixTimeStamp.getSeconds());
            return Y+M+D+h+m+s;
        }
    },
    // 获取对冲曲线图数据
    getChartInfo(data) {
        return http.post({
            url: '/admin/hedge/stats/chart',
            data,
            dataType: 'form',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
    }
}





